import { z } from 'zod';

export const Tier0 = 'none';
export const Tier1 = 'base';
export const Tier2 = 'chase';
export const Tier3 = 'grail';

export const TIERS = z.enum([Tier0, Tier1, Tier2, Tier3]);
